<script setup lang="ts">
  import { useApiRequestsAbort } from '@/shared/composables'
  import { FlowTravelersWidgetQC } from '@/widgets/Flow'
  useApiRequestsAbort()
</script>

<template>
  <FlowTravelersWidgetQC />
</template>
